"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultilineTextInput = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
const LinearProgress_1 = require("../LinearProgress/LinearProgress");
const ErrorMessage = Theme_1.styled.div `
  font-family: ${(props) => props.theme.font.family.proximaNova};
  margin: 5px 0px 0px 10px;
  color: ${(props) => props.theme.red};
  font-size: 0.75em;
  background-color: transparent;
`;
const InputGroup = Theme_1.styled.div `
  font-family: ${(props) => props.theme.font.family.proximaNova};
  flex: 1;
  background: ${(props) => props.variant === 'filled' ? props.theme.gray5 : 'transparent'};
  position: relative;
  padding: 15px 10px 10px 10px;
  border-bottom: 1px solid ${(props) => props.theme.gray4};
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  :hover {
    border-bottom: 1px solid
      ${(props) => !props.error && !props.disabled && props.theme.blue};
  }
  ${(props) => props.error && `border-bottom: 1px solid ${props.theme.red};`}
`;
const Styles = Theme_1.styled.div `
  .form__field_multi {
    resize: none;
    font-family: inherit;
    width: 100%;
    border: 0;
    outline: 0;
    font-size: 16px;
    color: ${(props) => props.theme.gray2};
    margin-top: 5px;
    background: transparent;
    transition: border-color 0.2s;
  }

  .form__field_multi::placeholder {
    color: transparent;
  }

  .form__field_multi:placeholder-shown ~ .form__label_multi {
    font-size: 16px;
    cursor: text;
    top: 20px;
  }

  label,
  .form__field_multi:focus ~ .form__label_multi {
    pointer-events: none;
    position: absolute;
    top: 5px;
    display: block;
    transition: 0.2s;
    font-size: 12px;
    color: ${(props) => props.theme.gray2};
  }

  .form__field_multi:focus ~ .form__label_multi {
    color: ${(props) => (props.error ? props.theme.red : props.theme.blue)};
  }
`;
exports.MultilineTextInput = react_1.default.forwardRef(function MultilineTextInput(props, ref) {
    const className = props.className ? props.className : '';
    const autoComplete = props.autoComplete === false ? 'off' : 'on';
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Styles, { error: props.error, style: props.style },
            react_1.default.createElement(InputGroup, { error: props.error, variant: props.variant, disabled: props.disabled },
                props.inputComponent ? (props.inputComponent) : (react_1.default.createElement("textarea", { rows: props.rows, id: "input_multi", className: `form__field_multi`, value: props.value, onChange: function (event) {
                        if (props.characterLimit) {
                            if (event.target.value.length <= props.characterLimit) {
                                props.onChange(event);
                            }
                        }
                        else {
                            props.onChange(event);
                        }
                    }, onBlur: props.onBlur, placeholder: props.label, onFocus: props.onFocus, autoComplete: autoComplete, ref: ref, disabled: props.disabled || false })),
                react_1.default.createElement("label", { htmlFor: "input_multi", className: "form__label_multi" }, props.label)),
            props.characterLimit && (react_1.default.createElement("div", { style: { fontSize: 'small' } },
                props.value.length,
                "/",
                props.characterLimit)),
            props.isLoading && react_1.default.createElement(LinearProgress_1.LinearProgress, null),
            props.error && react_1.default.createElement(ErrorMessage, null, props.error))));
});
//# sourceMappingURL=MultilineTextInput.js.map